export const LOAD_PRODUCTS_DATA = 'storeHome/LOAD_PRODUCTS_DATA';
export const SET_PRODUCTS_STATUS = 'storeHome/SET_PRODUCTS_STATUS';
export const SET_PRODUCTS_DATA = 'storeHome/SET_PRODUCTS_DATA';
export const SET_IS_STOCK_ORDER = 'storeHome/SET_IS_STOCK_ORDER';